import { IRootState } from 'affiny-core/modules/state';

export const selectIsSub = (state: IRootState): boolean =>
  state.subscription.isSub;

export const selectPass = (state: IRootState) => state.subscription.pass;

export const selectIsCacellable = (state: IRootState): boolean =>
  state.subscription.isCancellable;

export const selectIsAutorenewal = (state: IRootState): boolean =>
  state.subscription.isAutoRenewal;

export const selectIsReactivable = (state: IRootState): boolean =>
  state.subscription.isReactivable;
